// Import 3rd-party dependencies
import { Component, OnInit, OnDestroy } from '@angular/core';
import { SubSink } from 'subsink';

// Import project-specific dependencies
import { GlobalFunctionsService, IContentAdminLink } from '@app/services/global-functions/global-functions.service';
import { GLOBAL_FUNCTIONS_COMPONENT_CONSTS } from '@app/config/constants';

@Component({
  selector: 'app-global-functions',
  templateUrl: './global-functions.component.html',
  styleUrls: ['./global-functions.component.css']
})
export class GlobalFunctionsComponent implements OnInit, OnDestroy {
  private subs: SubSink;
  dataList: IContentAdminLink[];
  corporateDepartments: IContentAdminLink[];
  consts = GLOBAL_FUNCTIONS_COMPONENT_CONSTS;

  constructor(private globalFunctionsService: GlobalFunctionsService) {}

  ngOnInit(): void {
    // Get the regions and departments list from the GlobalFunctions.json
    this.subs = new SubSink();
    // load global function from json file
    /*
    this.subs.sink = this.globalFunctionsService.globalFunctions$.subscribe((result) => {
      const regionList = result[this.consts.DATA_LIST_TITLE_REGION].sort((a, b) => a.title.localeCompare(b.title));
      const departmentList = result[this.consts.DATA_LIST_TITLE_DEPARTMENT].sort((a, b) =>
        a.title.localeCompare(b.title)
      );
      this.dataList = [...departmentList, ...regionList];
      this.corporateDepartments = this.dataList.slice(this.consts.ITEMS_STARTING_POINT, this.consts.MAX_ITEMS);
    });
    */
    //load global function from cosmos DB
    this.subs.sink = this.globalFunctionsService.globalFunctionsAdminList$.subscribe((result) => {
      const groupedGlobalFunctions = this.groupBy(result);

      const departmentList = groupedGlobalFunctions[this.consts.SELECT_DEPARTMENT].sort((a, b) => a.index - b.index);

      const regionList = groupedGlobalFunctions[this.consts.SELECT_REGION].sort((a, b) => a.index - b.index);

      this.dataList = [...departmentList, ...regionList];
      this.corporateDepartments = this.dataList.slice(this.consts.ITEMS_STARTING_POINT, this.consts.MAX_ITEMS);
    });
  }

  groupBy(list: IContentAdminLink[]) {
    const groupedGlobalFunctions = list.reduce((group: { [key: string]: IContentAdminLink[] }, item) => {
      if (!group[item.type]) {
        group[item.type] = [];
      }
      group[item.type].push(item);
      return group;
    }, {});

    return groupedGlobalFunctions;
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  openLink(link: string): void {
    window.open(link, '_blank');
  }
}
